import React from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { ReactComponent as ArrowLeftSvg } from '@joinforma/ui/assets/icons/arrow-left.svg';
import Button from '@joinforma/ui/components/Button';
import {
  ButtonVariant,
  ButtonSize,
  ButtonType,
} from '@joinforma/ui/constants/properties';

const Page = styled.div<{ wide: boolean }>`
  max-width: ${({ wide }) => (wide ? '1048px' : '756px')};
  margin-left: auto;
  margin-right: auto;
  padding-top: 36px;
  background-color: ${({
    theme: {
      colors: {
        background: { primary },
      },
    },
  }) => primary};
`;

const Container = styled.div`
  display: inline-flex;
  align-items: baseline;
`;

const LinkButton = styled(Button).attrs({
  variant: ButtonVariant.GHOST,
  size: ButtonSize.SMALL,
  type: ButtonType.BUTTON,
  startIcon: ArrowLeftSvg,
})`
  flex: 1;
`;

const EnrollLayout = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const noBackButton = pathname.includes(
    'accounts/pretax/commuter-enroll-confirmed'
  );

  return (
    <Page wide={!noBackButton}>
      <Container>
        {!noBackButton && <LinkButton onClick={() => navigate(-1)} />}
        <Outlet />
      </Container>
    </Page>
  );
};

export default EnrollLayout;
